import * as Yup from "yup";
import {
  commonFieldsRules,
  commonFieldsRulesClose,
} from "../validation/validator";

const addRules = {
  //   addressText: Yup.string().typeError("Введите адрес дефекта"),
  ...commonFieldsRules,
  lightingWorkStartedTime: Yup.string()
    .nullable(true)
    .test(function (val) {
      if (typeof val === "string") {
        return (
          val.length === 5 ||
          !val.length ||
          this.createError({ message: "Проверьте корректность данных" })
        );
      }
      return true;
    })
    .required("Выберите время"),
  dateTimeWorkStarted: Yup.string().nullable(true).required("Выберите дату"),
};

const editRules = {
  ...addRules,
  //classifierTypeId: Yup.string().typeError("Выберите тип классификатора"),
  //objectTypeId: Yup.string().typeError("Выберите тип объекта"),
  //objectId: Yup.string().typeError("Выберите краткое наименование объекта"),
};

export const addSchemaPowerSupply = Yup.object().shape(addRules);
export const editSchemaPowerSupply = Yup.object().shape(editRules);
export const closeSchemaPowerSupply = Yup.object().shape({
  ...editRules,
  ...commonFieldsRulesClose,
});
